module.exports = __webpack_public_path__ + "static/img/ic_arrow.cf3d5b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/pc/ic_arrow.png
// module id = WT8M
// module chunks = 10